import { atom } from 'recoil';

export const errorFindingIdxState = atom<number | undefined>({
  key: 'errorFindingIdxState',
  default: undefined,
});
